export default __webpack_public_path__ + "static/G6_ND_25_2021RGB2Spiral-01 - Copy-207689234f166b40f9d560204f4950b3.svg";